import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

export default function Meta({ Title, Description, keywords }) {
    const Api_Url = process.env.REACT_APP_API_BASE_URL;
    const location = useLocation();

    const [title_seo, setTitle_Seo] = useState(Title || '');
    const [description_seo, setDescription] = useState(Description || '');
    const [keywords_seo, setKeyWords] = useState(keywords || '');

    useEffect(() => {
        // لو أي Prop جاية، امنع الـ API call
        if (title_seo || description_seo || keywords_seo) return;

        const rawPath = location.pathname === '/' ? 'home' : location.pathname.replace('/', '');
        let Url_Path = encodeURIComponent(rawPath);

        axios.get(`${Api_Url}/seo/page/${Url_Path}`)
            .then(res => {
                setTitle_Seo(res.data.title_seo);
                setDescription(res.data.description_seo);
                setKeyWords(res.data.keywords_seo);
            })
            .catch(error => {
                console.error('Failed to fetch meta data:', error);
            });
    }, [location.pathname, Title, Description, keywords]);

    return (
        <Helmet>
            <title>{title_seo}</title>
            <meta name="description" content={description_seo} />
            <meta name="keywords" content={keywords_seo} />
        </Helmet>
    );
}
